import styled, { css } from 'styled-components';
import { device } from '../breakpoints';
import {
    regularBlack,
    playGrey20,
    darkRed,
    regularWhite,
    regularYellow,
    fontWeightBold,
} from '../design-tokens';
import { playFontSize } from '../typography/helpers';
import { PlayBadge } from '../typography/PlayBadge.styles';
// eslint-disable-next-line import/no-cycle
import { PlayBadgeColors, PlayBadgeSize } from './PlayBadge';

const getColor = (color: PlayBadgeColors) => {
    switch (color) {
        case PlayBadgeColors.GREY:
            return css`
                background: ${playGrey20};
                color: ${regularWhite};
            `;
        case PlayBadgeColors.RED:
            return css`
                background: ${darkRed};
                color: ${regularWhite};
            `;
        case PlayBadgeColors.YELLOW:
            return css`
                background: ${regularYellow};
                color: ${regularBlack};
            `;
        case PlayBadgeColors.WHITE:
            return css`
                background: ${regularWhite};
                color: ${regularBlack};
            `;
        default:
            return css`
                background: ${playGrey20};
                color: ${regularWhite};
            `;
    }
};

const getSize = (size: PlayBadgeSize) => {
    switch (size) {
        case PlayBadgeSize.SMALL:
            return css`
                ${playFontSize(0.75)}
                padding: 2px;
                top: 2px;
                left: 2px;

                @media ${device.GteSmall} {
                    ${playFontSize(0.75)}
                    padding: 2px;
                }
            `;
        case PlayBadgeSize.LARGE:
            return css`
                @media ${device.GteSmall} {
                    ${playFontSize(1.5)}
                    padding: 7px;
                }
            `;
        case PlayBadgeSize.XLARGE:
            return css`
                ${playFontSize(1.3)}
                font-weight: ${fontWeightBold};
                padding: 5px;

                @media ${device.GteLarge} {
                    font-size: 20px;
                }
            `;
        default:
            return css``;
    }
};

type BadgeWrapperProps = {
    overlay: boolean;
    badgeColor: PlayBadgeColors;
    size: PlayBadgeSize;
};

export const BadgeWrapper = styled.div`
    ${PlayBadge}
    text-transform: uppercase;
    font-weight: bold;
    padding: 4px 5px;
    z-index: 1;
    display: inline-block;
    line-height: 1;

    @media ${device.GteMedium} {
        padding: 5px 6px;
    }

    ${(props: BadgeWrapperProps) =>
        props.overlay &&
        css`
            position: absolute;
            top: 5px;
            left: 5px;
        `}

    ${(props: BadgeWrapperProps) => getColor(props.badgeColor)}
    ${(props: BadgeWrapperProps) => getSize(props.size)}
`;

export const A11yText = styled.span`
    display: none;
`;
